// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__PlJNl","spin":"LoadingSpinner_spin__lDjej"};